import React, {useState} from 'react';
import './Select.scss';
import {Select, Table} from 'antd';
import {t} from 'react-switch-lang';

const {Option} = Select;

const SelectList = ({list, placeholder, selectedItem, disabled, selectValue, multiple, defaultValue}) => {
  const [selected, setSelected] = useState();

  /*** Passes selected value to Parent ***/
  function handleChange(value) {
    if (value === undefined) { /*** If clear select is clicked ***/
    setSelected(null);
      return false;
    }
    setSelected(value);
    return `${value}`;
  }

  let selectList = React.createRef();
  function handleClear() {
    /*** Do something on clear ***/
    // selectList.current
  }

  return (
    <Select placeholder={placeholder}
            style={{width: '100%'}}
            size={'large'}
            defaultValue={defaultValue}
            listHeight={'120px'}  /*** lineHeight must be added so that scroll bar shows properly ***/
            onChange={value => selectedItem(handleChange(value))}
            ref={selectList}
            onClear={handleClear}
            disabled={disabled}
            allowClear={true}
            value={selectValue ? placeholder : selected}
            mode={multiple? 'multiple': ''}
            notFoundContent={t('common.noData')}
            showSearch
            showArrow={true}
    >
      {list.map((value, index) => {
        return (
          <Option value={value} key={index}>{value}</Option>
        );
      })}
    </Select>
  );
};

export default SelectList;
